import AddApplicationUser from "components/application/add-user/AddUser";
import AddApplicationSubscription from "components/application/add-subscription/AddSubscription";
import CreateApplication from "components/application/create/Create";
import DeployApplication from "components/application/deploy/Deploy";
import PreviewApplication from "components/application/preview/Preview";
import PreviewJob from "components/job/preview/Preview";
import ImportApplication from "components/application/import/Import";
import EditApplication from "components/application/edit/Edit";
import EraseApplication from "components/application/erase/Erase";

import EditPrizeSupplier from "components/prize/supplier/edit/Edit";

import EditPrize from "components/prize/prize/edit/Edit";
import EditCategoryComponent from "../../prize/category/edit/Edit";
import CreateCategoryComponent from "../../prize/category/create/Create";

//TODO: types for constructor arguments
export const drawers: {
  [key: string]: Function;
} = {
  //TODO: activate via component class reference instead of new custom action name
  "application-add-user": AddApplicationUser,
  "application-add-subscription": AddApplicationSubscription,
  "create-application": CreateApplication,
  "deploy-application": DeployApplication,
  "erase-application": EraseApplication,
  "preview-application": PreviewApplication,
  "preview-job": PreviewJob,
  "import-application": ImportApplication,
  "edit-application": EditApplication,
  "edit-prize-supplier": EditPrizeSupplier,
  "edit-prize": EditPrize,
  "edit-category": EditCategoryComponent,
  "create-category": CreateCategoryComponent
};
